"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Bar_1 = __importDefault(require("./styledComponents/Bar"));
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var ZeroAxis_1 = __importDefault(require("./styledComponents/ZeroAxis"));
var BarScale_meta_1 = require("./BarScale.meta");
var Text_1 = __importDefault(require("../../svg/Text"));
var BarScale = /** @class */ (function (_super) {
    __extends(BarScale, _super);
    function BarScale(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = BarScale_meta_1.BAR_SCALE_CATEGORY_KEY;
        _this.componentKey = BarScale_meta_1.BAR_SCALE_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(BarScale.prototype, "container", {
        get: function () {
            return this.props.container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "label", {
        get: function () {
            return this.props.label || { text: '' };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "rect", {
        get: function () {
            return this.props.rect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "rectProps", {
        get: function () {
            return __assign(__assign({}, this.rect), { y: this.container.height / 2 - this.rect.height / 2, width: Math.abs(this.rect.width) });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "line", {
        get: function () {
            return this.props.line;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "lineProps", {
        get: function () {
            return __assign({ x1: this.line.x, x2: this.line.x, y1: 0, y2: this.container.height }, this.line);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "textProps", {
        get: function () {
            var _a = this.label.horizontalAlign, horizontalAlign = _a === void 0 ? 'edge' : _a;
            var _b = this.label, _c = _b.position, position = _c === void 0 ? 'outside' : _c, _d = _b.verticalAlign, verticalAlign = _d === void 0 ? 'center' : _d, _e = _b.verticalMargin, verticalMargin = _e === void 0 ? 0 : _e, _f = _b.horizontalMargin, horizontalMargin = _f === void 0 ? 1 : _f;
            var isNegativeBar = this.line.x > this.rect.x || this.line.x === this.container.width;
            var textProps = __assign(__assign({}, this.label.svgTextProperties), { x: 0, y: 0 });
            if (verticalAlign === 'center') {
                textProps.y = this.rectProps.y + this.rect.height / 2;
                textProps.dominantBaseline = 'central';
            }
            else if (verticalAlign === 'top') {
                textProps.y = this.rectProps.y + verticalMargin;
                textProps.dominantBaseline = 'hanging';
            }
            else {
                textProps.y = this.rectProps.y + this.rect.height - verticalMargin;
                textProps.dominantBaseline = 'text-bottom';
            }
            if (position === 'outside') {
                if (horizontalAlign === 'edge') {
                    textProps.x = this.line.x;
                    if (isNegativeBar) {
                        var width = this.rect.width;
                        if (width > 0) {
                            width = width * -1;
                        }
                        textProps.x += width - horizontalMargin;
                        textProps.textAnchor = 'end';
                    }
                    else {
                        textProps.x += this.rect.width + horizontalMargin;
                        textProps.textAnchor = 'start';
                    }
                }
                else if (horizontalAlign === 'axis') {
                    if (isNegativeBar) {
                        textProps.x = 0 + horizontalMargin;
                        textProps.textAnchor = 'start';
                    }
                    else {
                        textProps.x = this.container.width - horizontalMargin;
                        textProps.textAnchor = 'end';
                    }
                }
                else {
                    textProps.textAnchor = 'middle';
                    if (isNegativeBar) {
                        textProps.x = this.rect.x / 2;
                    }
                    else {
                        textProps.x = this.line.x + this.rect.width + (this.container.width - this.line.x - this.rect.width) / 2;
                    }
                }
            }
            else {
                if (this.canShowText && this.label.text === '0' && horizontalAlign === 'center') {
                    horizontalAlign = 'axis';
                }
                if (horizontalAlign === 'edge') {
                    textProps.x = this.line.x;
                    if (isNegativeBar) {
                        var width = this.rect.width;
                        if (width > 0) {
                            width = width * -1;
                        }
                        textProps.x += width + horizontalMargin;
                        textProps.textAnchor = 'start';
                    }
                    else {
                        textProps.x += this.rect.width - horizontalMargin;
                        textProps.textAnchor = 'end';
                    }
                }
                else if (horizontalAlign === 'axis') {
                    if (isNegativeBar) {
                        textProps.x = this.line.x - horizontalMargin;
                        textProps.textAnchor = 'end';
                    }
                    else {
                        textProps.x = this.line.x + horizontalMargin;
                        textProps.textAnchor = 'start';
                    }
                }
                else {
                    textProps.textAnchor = 'middle';
                    if (isNegativeBar) {
                        textProps.x = this.rect.x + this.rectProps.width / 2;
                    }
                    else {
                        textProps.x = this.line.x + this.rectProps.width / 2;
                    }
                }
            }
            return textProps;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarScale.prototype, "canShowText", {
        get: function () {
            var _a = this.label, text = _a.text, _b = _a.hide, hide = _b === void 0 ? false : _b, _c = _a.showZero, showZero = _c === void 0 ? false : _c;
            if (!hide && typeof text === 'string' && text !== '' && (showZero || text !== '0')) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    BarScale.prototype.render = function () {
        var className = this.props.className;
        var text = this.label.text;
        return (react_1.default.createElement(Wrapper_1.default, __assign({ className: className }, this.container, { width: this.container.width, height: this.container.height, "aria-label": text }),
            react_1.default.createElement("title", null, text),
            react_1.default.createElement(Bar_1.default, __assign({}, this.rectProps)),
            react_1.default.createElement(ZeroAxis_1.default, __assign({}, this.lineProps)),
            this.canShowText && react_1.default.createElement(Text_1.default, __assign({}, this.textProps), text)));
    };
    BarScale = __decorate([
        mobx_react_1.observer
    ], BarScale);
    return BarScale;
}(shared_1.ComponentBase));
exports.BarScale = BarScale;
exports.default = shared_1.InjectedStyledComponent(BarScale, BarScale_meta_1.BAR_SCALE_CATEGORY_KEY, BarScale_meta_1.BAR_SCALE_COMPONENT_KEY);
